<template>
<div class="selectBar tg-selectbar">
	<div class="padding20 borderb flex-container bg-white selectTab" :class="{active:showSelectList}" style="line-height:0.56666667rem">
		<div class="flex1 text-center text-limit1" :data-scp="item.scpCD" v-for="item in data.items" v-html="item.title+iconHtml" :class="{borderr:$index!=data.items.length-1}" @click="tabClick($index,item)">

		</div>
	</div>
	<div class="selectList" v-show="showSelectList" @click="tabClick(listActiveIndex, data.items[listActiveIndex])">
		<div class="listGroup bg-white">
			<div class="listGroup_item padding20"  v-for="item in data.items[listActiveIndex].items" @click.stop="listClick(item)" :data-scp="item.scpCD">
				<component :is="selectItemTpl" :item="item" :curr="item.title==data.items[listActiveIndex].title"></component>
				<!--<span v-text="item.title" :class="{'text-green':item.title==data.items[listActiveIndex].title}"></span>-->
				<!--<i class="icon icon-check float-right text-green fs-20 marginr20" v-if="item.title==data.items[listActiveIndex].title"></i>-->
			</div>
		</div>
	</div>
</div>
</template>
<script>
// var arr=[],arr2=[]
// for(let i=0;i<50;i++){
// 	arr[i]={title:'分类'+i}
// 	arr2[i]={title:'排序'+i}
// }
export default {
	props: {
		data: {
			type: Object
			, default: {
				items: [
					{
						title:'分类',
						items:[]
					},{
						title:'排序',
						items:[]
					}
				]
			}
		}
		, selectItemTpl: {
			type: String
			, default: 'tg-selectbar-default-item'
		}
	},
	data(){
		return{
			showSelectList:false,
			listActiveIndex:0,
			iconHtml:'<i class="icon icon-unfold marginl20"></i>'
		}
	},
	watch:{
		showSelectList:function(){
		}
	},
	ready:function(){
		if(!this.$el.id){
			this.$el.setAttribute('id',_.uniqueId('selectbar_'))
		}
	},
	methods:{
		tabClick:function(index,item){
			if(this.showSelectList){
				if(this.listActiveIndex==index){
					this.showSelectList=!this.showSelectList
				}else{
					this.listActiveIndex=index;
				}
			}else{
				this.listActiveIndex=index;
				this.showSelectList=true;
			}
			this.$dispatch('tg_selectbar_tabClick',item,this);
//			location.hash=""
		},
		listClick:function(item){
			this.data.items[this.listActiveIndex].title=item.title;
			this.showSelectList=false;
			this.$dispatch('tg_selectbar_listClick',item,this);
//			location.hash="#"+this.$el.id;
		}
	}
	, events: {
		// 父级发送事件 重置选项
		resetSelect: function(index, titleIndex){
			this.listActiveIndex = index;
			this.data.items[this.listActiveIndex].title = this.data.items[this.listActiveIndex].items[titleIndex].title;
		}
		, closeSelect: function(){	// 由父级关闭 selectbar 的选择状态
			this.showSelectList = false;
		}
	}
};
</script>
<style lang="scss">
	.selectBar .selectList{
		position:fixed;
		top:1.1rem;
		width:100%;
		bottom:0;
		z-index:2;
		overflow: auto;
		background-color:rgba(0,0,0,0.5);
	}
	.selectTab.active{
		position:fixed;
		top:0px;
		width:100%;
		z-index:9;
	}
</style>